export const nodeConstants = {
  NODE_HAS_ERRORED: "NODE_HAS_ERRORED",
  NODE_IS_LOADING: "NODE_IS_LOADING",
  NODE_FETCH_DATA_SUCCESS: "NODE_FETCH_DATA_SUCCESS",
  NODE_SET_ROOT: "NODE_SET_ROOT",
};
